/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';
import type { SubAssetType } from './SubAssetType';
import {
    SubAssetTypeFromJSON,
    SubAssetTypeFromJSONTyped,
    SubAssetTypeToJSON,
} from './SubAssetType';

/**
 * 
 * @export
 * @interface EquityCreateRequest
 */
export interface EquityCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    cusip: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    isin: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    sedol?: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    primaryExchange: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    mic?: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof EquityCreateRequest
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof EquityCreateRequest
     */
    assetType: AssetType;
    /**
     * 
     * @type {SubAssetType}
     * @memberof EquityCreateRequest
     */
    subAssetType?: SubAssetType;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    gicsCode?: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    gicsSector?: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    gicsIndustry?: string;
    /**
     * 
     * @type {number}
     * @memberof EquityCreateRequest
     */
    priceMultiplier: number;
    /**
     * 
     * @type {number}
     * @memberof EquityCreateRequest
     */
    contractMultiplier: number;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof EquityCreateRequest
     */
    coId?: string;
}



/**
 * Check if a given object implements the EquityCreateRequest interface.
 */
export function instanceOfEquityCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "cusip" in value;
    isInstance = isInstance && "isin" in value;
    isInstance = isInstance && "primaryExchange" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "priceMultiplier" in value;
    isInstance = isInstance && "contractMultiplier" in value;

    return isInstance;
}

export function EquityCreateRequestFromJSON(json: any): EquityCreateRequest {
    return EquityCreateRequestFromJSONTyped(json, false);
}

export function EquityCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquityCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
        'symbol': json['symbol'],
        'cusip': json['cusip'],
        'isin': json['isin'],
        'sedol': !exists(json, 'sedol') ? undefined : json['sedol'],
        'primaryExchange': json['primary_exchange'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'mic': !exists(json, 'mic') ? undefined : json['mic'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'subAssetType': !exists(json, 'sub_asset_type') ? undefined : SubAssetTypeFromJSON(json['sub_asset_type']),
        'gicsCode': !exists(json, 'gics_code') ? undefined : json['gics_code'],
        'gicsSector': !exists(json, 'gics_sector') ? undefined : json['gics_sector'],
        'gicsIndustry': !exists(json, 'gics_industry') ? undefined : json['gics_industry'],
        'priceMultiplier': json['price_multiplier'],
        'contractMultiplier': json['contract_multiplier'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'coId': !exists(json, 'co_id') ? undefined : json['co_id'],
    };
}

export function EquityCreateRequestToJSON(value?: EquityCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'symbol': value.symbol,
        'cusip': value.cusip,
        'isin': value.isin,
        'sedol': value.sedol,
        'primary_exchange': value.primaryExchange,
        'country': value.country,
        'mic': value.mic,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sub_asset_type': SubAssetTypeToJSON(value.subAssetType),
        'gics_code': value.gicsCode,
        'gics_sector': value.gicsSector,
        'gics_industry': value.gicsIndustry,
        'price_multiplier': value.priceMultiplier,
        'contract_multiplier': value.contractMultiplier,
        'sc_id': value.scId,
        'co_id': value.coId,
    };
}

